export function getPortKey(port: number, protocol: string) {
  return `${protocol.trim()}_${Number(port)}`;
}
export function getServiceKey(service: string, protocol: string) {
  return `${protocol.trim()}_s_${service}`;
}
